<template>
    <modal @close="editUserPreferencesCancelClick" class="edit-modal" hideFooter id="edit-user-preferences">
        <div class="td-edit-container one-step">
            <div class="pagination">
                <div class="form-name">
                    <h3>Edit Preferences</h3>
                    <p>
                        Tailor your experience.
                    </p>
                    <p>
                        Manage your preferences and customize how you interact with our website. Your selections help us provide you with a more personalized and relevant experience.
                    </p>
                </div>
            </div>
            <div class="edit-pages">
                <form>
                    <h3>Edit Preferences</h3>
                    <div class="md-col-2">
                        <div class="column">

                            <div class="mt-3">
                                <div class="td-autocomplete form-item">
                                    <timezone-lookup @select-timezone="selectTimeZone"
                                                     :selected-time-zone="updateModel.timeZone"
                                                     :time-zones="timeZones">
                                    </timezone-lookup>
                                </div>
                            </div>

                            <div class="mt-3">
                                <label class="td-label td-text-bold mt-0">Unit of Measure:</label>
                                <select v-model="updateModel.measureUnit" required>
                                    <option :value="MeasureUnit.Imperial"> {{measureUnitDisplay(MeasureUnit.Imperial)}} </option>
                                    <option :value="MeasureUnit.Metric"> {{measureUnitDisplay(MeasureUnit.Metric)}} </option>
                                </select>
                            </div>

                            <div class="mt-3" v-if="showAdvancedPreferences == true">
                                <label class="td-label td-text-bold mt-0">Default Search Services:</label>
                                <div class="service td-autocomplete">
                                    <div class="autocomplete-input">
                                        <div class="td-selected-input" name="service" v-for="service in updateModel.defaultServices">
                                            <span>
                                                {{ serviceDisplay(service) }}
                                                <a class="service-close" href="#" @click.prevent="deselectService(service)">
                                                    <icon type="solid" name="faXmark" aria-hidden="true"></icon>
                                                </a>
                                            </span>
                                        </div>
                                        <input id="default-services-input" type="text" placeholder="Type service name and select to add" name="services" v-model="searchTermService" />
                                    </div>
                                    <div :class="[searchTermService && searchTermService != '' ? 'show-results' : 'hide-results', 'autocomplete-results']">
                                        <ul class="results-list">
                                            <li v-for="service in getNotSelectedServices()">
                                                <a @click.prevent="selectService(service.code)" href="#">{{service.name}}</a>
                                            </li>
                                        </ul>
                                        <icon @click="searchTermService = ''" name="faXmark" type="solid" class="td-text-danger close-list"></icon>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="column">
                            <div class="mt-3">
                                <label class="td-checkbox-label td-text-bold mt-0">
                                    Receive Newsletter
                                    <input v-model="updateModel.receiveProductUpdates" name="receiveProductUpdates" type="checkbox" />
                                    <span></span>
                                </label>
                            </div>

                            <div class="mt-3">
                                <label class="td-checkbox-label td-text-bold mt-0">
                                    Receive Reports
                                    <input v-model="updateModel.receiveReports" name="receiveReports" type="checkbox" />
                                    <span></span>
                                </label>
                            </div>

                            <div class="mt-3" v-if="showAdvancedPreferences == true">
                                <label class="td-checkbox-label td-text-bold mt-0">
                                    Hide Managed Services
                                    <input v-model="updateModel.hideManagedServices" name="hideManagedServices" type="checkbox" />
                                    <span></span>
                                </label>
                            </div>

                            <div class="mt-3" v-if="showAdvancedPreferences == true">
                                <label class="td-checkbox-label td-text-bold mt-0">
                                    Search By Distance
                                    <input v-model="updateModel.searchByDistance" name="searchByDistance" type="checkbox" />
                                    <span></span>
                                </label>
                            </div>

                            <div class="mt-3" v-if="showAdvancedPreferences == true">
                                <label class="td-label td-text-bold mt-0">Search Private Radius:</label>
                                <select v-model="updateModel.searchPrivateRadius" required>
                                    <option :value="SearchRadiusPreference.Zero"> {{searchDistanceDisplay(SearchRadiusPreference.Zero)}} </option>
                                    <option :value="SearchRadiusPreference.five"> {{searchDistanceDisplay(SearchRadiusPreference.five)}} </option>
                                    <option :value="SearchRadiusPreference.ten"> {{searchDistanceDisplay(SearchRadiusPreference.ten)}} </option>
                                    <option :value="SearchRadiusPreference.fifteen"> {{searchDistanceDisplay(SearchRadiusPreference.fifteen)}} </option>
                                    <option :value="SearchRadiusPreference.twenty"> {{searchDistanceDisplay(SearchRadiusPreference.twenty)}} </option>
                                    <option :value="SearchRadiusPreference.twentyFive"> {{searchDistanceDisplay(SearchRadiusPreference.twentyFive)}} </option>
                                    <option :value="SearchRadiusPreference.fifty"> {{searchDistanceDisplay(SearchRadiusPreference.fifty)}} </option>
                                    <option :value="SearchRadiusPreference.hundred"> {{searchDistanceDisplay(SearchRadiusPreference.hundred)}} </option>
                                </select>
                            </div>

                            <div class="mt-3" v-if="showAdvancedPreferences == true">
                                <label class="td-label td-text-bold mt-0">Search Preferred Radius:</label>
                                <select v-model="updateModel.searchPreferredRadius" required>
                                    <option :value="SearchRadiusPreference.Zero"> {{ searchDistanceDisplay(SearchRadiusPreference.Zero) }} </option>
                                    <option :value="SearchRadiusPreference.five"> {{ searchDistanceDisplay(SearchRadiusPreference.five) }} </option>
                                    <option :value="SearchRadiusPreference.ten"> {{ searchDistanceDisplay(SearchRadiusPreference.ten) }} </option>
                                    <option :value="SearchRadiusPreference.fifteen"> {{ searchDistanceDisplay(SearchRadiusPreference.fifteen) }} </option>
                                    <option :value="SearchRadiusPreference.twenty"> {{ searchDistanceDisplay(SearchRadiusPreference.twenty) }} </option>
                                    <option :value="SearchRadiusPreference.twentyFive"> {{ searchDistanceDisplay(SearchRadiusPreference.twentyFive) }} </option>
                                    <option :value="SearchRadiusPreference.fifty"> {{ searchDistanceDisplay(SearchRadiusPreference.fifty) }} </option>
                                    <option :value="SearchRadiusPreference.hundred"> {{ searchDistanceDisplay(SearchRadiusPreference.hundred) }} </option>
                                </select>
                            </div>
                        </div>
                    </div>
                </form>

                <div class="actions">
                    <div>
                        <button class="td-btn primary-outlined" @click="editUserPreferencesCancelClick">Cancel</button>
                    </div>
                    <div class="save-btn">
                        <button class="td-btn btn primary" @click="editUserPreferencesSaveClick"><span v-if="isLoading"><icon name="faSpinner" type="solid" spin></icon>&nbsp;</span>Save</button>
                    </div>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
    import script from './EditUserPreferences';
    export default script;
</script>
<style lang="less">
    @import './EditUserPreferences.less';
</style>